// src/App.js
import React,{ useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Construction from './Construction';
import Healthcare from './Healthcare';
import './App.css';
import emailjs from 'emailjs-com';
import { Helmet } from 'react-helmet';



function App() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_binrjfb', 'template_9wyqr1m', form.current, 'zVrq8zSYtHHUafXC9')
    .then(() => {
          alert('Message sent successfully!');
        }, (error) => {
          alert('Failed to send message. Please try again.');
        });
      };

  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>AnalyticaNova</title>
          <meta name="description" content="Explore real-time analytics and urban data visualizations tailored for decision-makers." />
        </Helmet>
        <header className="nav-bar">
          <div className="logo">
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
              <img src="/comp_logo2.png" alt="Company Logo" style={{ height: "40px", marginRight: "12px" }} />
              AnalyticaNova
            </Link>
          </div>
          <nav className="nav-links">
            <a href="#services">Services</a>
            <a href="#industry-solutions">Industry Solutions</a>
            {/*
            <div className="dropdown">
              <span className="dropbtn">Verticals</span>
              <div className="dropdown-content">
                <Link to="/construction">Construction</Link>
                <Link to="/healthcare">Healthcare</Link>
              </div>
            </div>
            */}
            <a href="#features">Features</a>
            <a href="#work-with-us">Work with us</a>
            <a href="#contact">Contact</a>
          </nav>

        </header>
        <Routes>
          <Route path="/construction" element={<Construction />} />
          <Route path="/healthcare" element={<Healthcare />} />
          
          <Route
            path="/"
            element={
              <>
                <main className="hero-section">
                  <div className="hero-content">
                    <h1>
                      Analytics. Intelligence. Action.
                    </h1>
                    <p>
                      AnalyticaNova helps organizations transform data into actionable intelligence, smarter decisions and measurable business outcomes.
                      We combine business understanding, analytics, AI and experienced leadership to solve high-value problems across customer growth, marketing, sales, operations and strategy.
                    </p>
                    <a href="#contact" className="hero-cta">Get Started</a>
                  </div>
                  <div className="hero-image">
                    <img src="/Hero-Image.webp" alt="Analytics Graph" />
                    <div className="growth-indicator">
                      <p>
                        Data is everywhere.
                        Actionable intelligence isn't.
                      </p>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <h3 style={{ margin: 0 }}>+160%</h3>
                        <img src="/growth.png" alt="Growth Arrow" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
                      </div>
                    </div>
                  </div>
                </main>
                {/* Services Section */}
                <section id="services" className="services-section">
                  <h2>Analytics & AI Consulting</h2>
                  <p> Comprehensive data analytics & AI solutions tailored to your business needs</p>
                  <div className="services-list">
                    <div className="service-card">
                      <img
                        src="/Data-Analytics-logo.png"
                        alt="Data Analytics Logo"
                        className="service-logo"
                        style={{ width: "50px", marginBottom: "6px", display: "block", marginLeft: 0 }}
                      />
                      <h3>Analytics Strategy & Transformation</h3>
                      <p>Know Where to Start. Know What Matters.</p>
                      <ul className="tick-list" style={{ textAlign: "left", margin: "16px 0 0 0", paddingLeft: "20px" }}>
                        <li>Analytics maturity assessment</li>
                        <li>Analytics strategy</li>
                        <li>Analytics roadmap</li>
                        <li>KPI Framework</li>
                        <li>Data & reporting assessment</li>
                        <li>Analytics operating model</li>
                        <li>Analytics CoE design</li>
                      </ul>
                    </div>
                    <div className="service-card">
                      <img
                        src="/market-research-logo.jpg"
                        alt="Market Research Logo"
                        className="service-logo"
                        style={{ width: "50px", marginBottom: "6px", display: "block", marginLeft: 0 }}
                      />
                      <h3>Customer & Marketing Intelligence</h3>
                      <p>Turn Customer Data Into Growth.</p>
                      <ul className="tick-list" style={{ textAlign: "left", margin: "16px 0 0 0", paddingLeft: "20px" }}>
                        <li>Customer segmentation</li>
                        <li>Customer lifetime value</li>
                        <li>Customer acquisition</li>
                        <li>Churn prediction</li>
                        <li>Cross-sell / upsell</li>
                        <li>Lead scoring</li>
                        <li>Marketing Mix Modeling</li>
                      </ul>
                    </div>
                    <div className="service-card">
                      <img
                        src="/strategic-consulting-logo.jpg"
                        alt="Strategic Consulting Logo"
                        className="service-logo"
                        style={{ width: "50px", marginBottom: "6px", display: "block", marginLeft: 0 }}
                      />
                      <h3>AI & Advanced Analytics</h3>
                      <p>Move From AI Experiments to Business Impact.</p>
                      <ul className="tick-list" style={{ textAlign: "left", margin: "16px 0 0 0", paddingLeft: "20px" }}>
                        <li>Predictive analytics</li>
                        <li>Forecasting</li>
                        <li>Propensity models</li>
                        <li>Churn prediction</li>
                        <li>AI-powered customer intelligence</li>
                        <li>Call transcript analytics</li>
                        <li>AI-assisted decision intelligence</li>
                      </ul>
                    </div>
                    <div className="service-card">
                      <img
                        src="/functional_analytics-logo.png"
                        alt="Functional Analytics Logo"
                        className="service-logo"
                        style={{ width: "50px", marginBottom: "6px", display: "block", marginLeft: 0 }}
                      />
                      <h3>Fractional Analytics Leadership</h3>
                      <p>Senior Analytics Leadership — Without the Full-Time Executive Cost.</p>
                      <ul className="tick-list" style={{ textAlign: "left", margin: "16px 0 0 0", paddingLeft: "20px" }}>
                        <li>Analytics strategy</li>
                        <li>Leadership</li>
                        <li>Hiring</li>
                        <li>Analytics roadmap</li>
                        <li>Project prioritization</li>
                        <li>AI strategy</li>
                        <li>Executive communication</li>
                      </ul>
                    </div>
                  </div>
                </section>

                
                {/* Industry Solutions Section */}
                <section id="industry-solutions" className="industry-section">
                  <h2>Industry Solutions</h2>
                  <p className="industry-intro">
                    We bring the right data, analytics, and AI capabilities to the decisions that matter most in your industry.
                  </p>

                  <div className="industry-grid">
                    <article className="industry-card">
                      <span className="industry-number">01</span>
                      <h3>Healthcare</h3>
                      <p>Turn patient, provider, and operational data into better outcomes, smarter resource planning, and sustainable growth.</p>
                    </article>
                    <article className="industry-card">
                      <span className="industry-number">02</span>
                      <h3>Construction &amp; Real Estate</h3>
                      <p>Identify high-value projects, understand markets, and make confident decisions across development and investment cycles.</p>
                    </article>
                    <article className="industry-card">
                      <span className="industry-number">03</span>
                      <h3>Consumer/Retail</h3>
                      <p>Strengthen customer growth with sharper segmentation, demand insight, pricing intelligence, and retention analytics.</p>
                    </article>
                    <article className="industry-card">
                      <span className="industry-number">04</span>
                      <h3>B2B/SaaS</h3>
                      <p>Improve acquisition, expansion, and retention with lifecycle intelligence built around your customers and revenue model.</p>
                    </article>
                    <article className="industry-card">
                      <span className="industry-number">05</span>
                      <h3>Manufacturing</h3>
                      <p>Use connected operational data to improve forecasting, efficiency, quality, and supply chain decision-making.</p>
                    </article>
                  </div>
                </section>



                {/* Features Section */}
                <section id="features" className="features-section">
                  <h2>Why Choose AnalyticaNova?</h2>
                  <p> Business First. Analytics Second. Impact Always.</p>
                  <div className="features-list">
                    <div className="feature-card">
                      <span className="feature-number">01</span>
                      <h3>We Start With the Business Problem</h3>
                      <p>We don't begin with technology. We begin with the decision you need to make better and the business value behind it.</p>
                    </div>
                    <div className="feature-card">
                      <span className="feature-number">02</span>
                      <h3>21+ Years of Analytics Leadership</h3>
                      <p>Our approach is shaped by more than two decades of building analytics teams, Centres of Excellence and solutions inside global organizations.</p>
                    </div>
                    <div className="feature-card">
                      <span className="feature-number">03</span>
                      <h3>Strategy Meets Execution</h3>
                      <p>From identifying the right opportunity to implementing the solution and driving adoption, we stay focused on turning ideas into outcomes.</p>
                    </div>
                    <div className="feature-card">
                      <span className="feature-number">04</span>
                      <h3>Outcomes Over Outputs</h3>
                      <p>We don't measure success by dashboards, models or reports delivered. We measure it by business impact—growth, conversion, retention, ROI, efficiency and better decisions.</p>
                    </div>
                    <div className="feature-card">
                      <span className="feature-number">05</span>
                      <h3>Analytics + AI + Business Judgment</h3>
                      <p>We combine data, analytics and AI with practical business judgment to build solutions that organizations can actually use.</p>
                    </div>
                    <div className="feature-card">
                      <span className="feature-number">06</span>
                      <h3>Cross-Functional Thinking</h3>
                      <p>Customers, marketing, sales, pricing, finance and operations don't exist in silos. Neither should your analytics.</p>
                    </div>
                  </div>
                </section>

                {/* Work With Us Section */}
                <section id="work-with-us" className="work-section">
                  <h2>Ways to work with us</h2>
                  <div className="work-grid">
                    <article className="work-card">
                      <span className="work-number">01</span>
                      <h3>Assess</h3>
                      <p>
                        Analytics Opportunity Assessment
                        Identify where analytics and AI can create the greatest business impact.
                      </p>
                      <span className="work-duration">2 to 3 weeks</span>
                    </article>
                    <article className="work-card">
                      <span className="work-number">02</span>
                      <h3>Accelerate</h3>
                      <p>
                        Analytics Transformation Projects
                        Solve specific high-value business problems across customer, marketing, sales, operations and AI.  
                      </p>
                      <span className="work-duration">4–12 weeks</span>
                    </article>
                    <article className="work-card">
                      <span className="work-number">03</span>
                      <h3>Lead</h3>
                      <p>Fractional Analytics Leadership
                        Get experienced analytics leadership without hiring a full-time executive.</p>
                      <span className="work-duration">3–12 months</span>
                    </article>
                    <article className="work-card">
                      <span className="work-number">04</span>
                      <h3>Build</h3>
                      <p>Custom Analytics &amp; AI Solutions
                        Develop tailored solutions to address your unique business challenges.</p>
                      <span className="work-duration">Depends on the complexity of the problem</span>
                    </article>
                  </div>
                </section>

                {/* Contact Section */}
                <section id="contact" className="contact-section">
                  <h2>Get In Touch</h2>
                  <p> Ready to transform your data into actionable insights? Let's discuss how we can help your business grow.</p>
                  <form className="contact-form" ref={form} onSubmit={sendEmail}>
                    <div className="form-row">
                      <input type="text" name="fullName" placeholder="Full Name" required />
                      <input type="email" name="email" placeholder="Email Address" required />
                    </div>
                    <div className="form-row">
                      <input type="tel" name="phone" placeholder="Phone Number" />
                      <input type="text" name="company" placeholder="Company Name" />
                    </div>
                    <div className="form-row">
                      <select name="interest" required defaultValue="">
                        <option value="" disabled>
                          Area of Interest
                        </option>
                        <option>Analytics Strategy & Transformation</option>
                        <option>Customer Analytics & Intelligence</option>
                        <option>Marketing Analytics & ROI</option>
                        <option>Sales & Revenue Analytics</option>
                        <option>AI & Advanced Analytics</option>
                        <option>Data & BI / Decision Dashboards</option>
                        <option>Fractional Analytics Leadership</option>
                        <option>Analytics CoE / Team Building</option>
                        <option>Industry-Specific Analytics Solutions</option>
                        <option>Analytics Opportunity Assessment</option>
                        <option>Other / Not Sure — Help Me Identify the Right Solution</option>
                      </select>
                    </div>
                    <div className="form-row" >
                      <textarea name="message" placeholder="Message" rows="4" required></textarea>
                    </div>
                    <button type="submit" className="contact-submit">Send Message</button>
                    <p className="contact-note">
                      All fields are mandatory. We respect your privacy and will never share your information.
                      <br />
                      Contact us on - <a href="mailto:contactus@analyticanova.com">contactus@analyticanova.com</a>
                      <br />
                      Call us on - <a href="tel:+916360978065">+91 6360978065</a>
                    </p>
                    
                  </form>
                  
                </section>
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;